module.exports = __webpack_public_path__ + "static/ApercuPro-Light-d201854c70f5f3345fdea4868e9c55df.woff";